import { ChangeDetectionStrategy, Component, ElementRef, inject, output } from '@angular/core';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';
import { QrcodeComponent } from '@app/components/qrcode/qrcode.component';

@Component({
  selector: 'app-more-gift-cards',
  templateUrl: './gift-cards.component.html',
  styleUrl: './gift-cards.component.scss',
  imports: [
    PageHeaderComponent,
    QrcodeComponent,
  ],
  host: {
    class: 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GiftCardsComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    element: this.elementRef.nativeElement,
  };

  public readonly back = output();

}
